<!--
@Author: MIYONGLE
@Desc: 首页
@Date: 2021-04-16 18时
-->
<template>
  <div id="carouselCon">
    <!-- 轮播 -->
    <el-carousel trigger="click" height="720px" id="carousel">
      <el-carousel-item v-for="item in bannarConList" :key="item.title">
        <div :style="{ 'background-image': 'url(' + item.bg + ')' }">
          <div class="min-width-pc bannar_lunbo-con">
            <div class="bannar_lunbo_item">
              <span>{{ item.title1 }}</span>
              <span>{{ item.title2 }}</span>
              <span>{{ item.desc }}</span>
              <span @click="jumpSection(item.btnTxt)">{{ item.btnTxt }}</span>
            </div>
            <img :src="item.src" alt="慧用工" />
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <!-- 我们能为你做什么 -->
    <span class="title-txt paddingTop88 ">我们能为你做什么</span>

    <div class="page-sec1 min-width-pc clearfix">
      <div
        class="page-sec1-list"
        v-for="(item, index) in textList"
        :key="index"
        @mouseenter="item.isDisplay = true"
        @mouseleave="item.isDisplay = false"
      >
        <div class="page-sec1-list-text">
          <img :src="item.src" alt="慧用工" />
          <span>{{ item.text }}</span>
        </div>

        <transition name="fade">
          <div class="page-sec1-model" v-show="item.isDisplay">
            <span>{{ item.text }}</span>
            <span>{{ item.desc }}</span>
          </div>
        </transition>
      </div>
    </div>

    <!-- 我们的服务行业 -->
    <span class="title-txt paddingTop88" id="serviceTrade">我们的服务行业</span>

    <!-- 手风琴 -->
    <div class="page-sec2 min-width-pc">
      <div
        v-for="(item, index) in serviceConList"
        :key="index"
        @mouseover="enterMth(item)"
      >
        <div class="page-sec2-list">
          <div
            :class="item.classNameActive"
            :style="{ 'background-image': 'url(' + item.src + ')' }"
          ></div>
          <span :class="item.className">
            <i v-if="icpBtn && item.text1 == '时尚秀场'">时尚秀场</i>
            <i v-else>{{ item.text }}</i>
          </span>
        </div>
      </div>
    </div>

    <!-- 地图-->
    <div class="page-sec3">
      <div class="page-sec3-con min-width-pc">
        <img
          src="../../../static/pc/indexPage/home_map.png"
          alt="慧用工"
          class="page-sec3-img"
        />

        <div class="page-sec3-sum">
          <div
            class="page-sec3-sum-list marquee-line"
            v-for="(item, index) in mapConList"
            :key="index"
          >
            <span v-if="item.text == '服务行业' || item.text == '服务企业'"
              >{{ item.numberTemp }}+</span
            >
            <span v-else-if="item.text == '服务自由职业者'"
              >{{ item.numberTemp }}万+</span
            >
            <span v-else>{{ item.numberTemp }}亿+</span>
            <span>{{ item.text }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <span class="title-txt paddingTop88" id="coopartner">合作伙伴</span>

    <div class="min-width-pc page-sec4">
      <img
        src="../../../static/pc/indexPage/home_panter_logo.png"
        alt="慧用工"
      />
    </div>

    <!-- 底部悬浮框 -->
    <pc-suspension-dialog :source="sourceF"></pc-suspension-dialog>

    <!-- 页面form -->
    <pc-form :source="source" class="marginTop88" id="anchor"
      ><span class="title-txt pc-form-img"
        >慧用工 | 致力于助力每一个优秀的公司</span
      ></pc-form
    >

    <!-- 弹窗form -->
    <pc-form-dialog :source="source"
      ><span class="pc-form-text"
        >慧用工｜致力于助力每一个优秀的公司</span
      ></pc-form-dialog
    >
  </div>
</template>

<script type="text/javascript">
import pcForm from "../../components/pcForm.vue";
import {
  WECANDOLIST,
  SERVICECONLIST,
  MAP_CON_LIST,
  BANNARCONLIST
} from "../../service/businessConsts";
import { jumpAnchorPoint, checkNull } from "../../filters/filters";
import pcFormDialog from "../../components/pcFormDialog.vue";
import pcSuspensionDialog from "../../components/pcSuspensionDialog";

export default {
  name: "index-page",

  data() {
    return {
      source: "",
      sourceF: "",
      textList: WECANDOLIST,
      serviceConList: SERVICECONLIST,
      mapConList: MAP_CON_LIST,
      autoplay: true,
      bannarConList: BANNARCONLIST,
      setTimeOutFun: null,
      timerTemp: null,
      icpBtn: false //只有在慧薪下用此处改成fasle，
    };
  },

  components: {
    "pc-form": pcForm,
    "pc-form-dialog": pcFormDialog,
    "pc-suspension-dialog": pcSuspensionDialog
  },

  created() {
    this.$nextTick(() => {
      if (!checkNull(this.$route.query.from)) {
        let str = "#" + this.$route.query.from;
        jumpAnchorPoint(str);
      }
    });

    // 只在慧薪域名下弹ICP处理用的二维码
    this.whichAddress = window.location.hostname;
    if (
      this.whichAddress === "www.hvcin.com" ||
      this.whichAddress === "hvcin.com"
    ) {
      this.icpBtn = true;
    }

    // source来源：：
    let hash = window.location.hash;
    this.source =
      hash.indexOf("source") > 0
        ? hash.substring(hash.indexOf("source")) + "&pageFrom=sy"
        : "&pageFrom=sy";
     // 用于底部悬浮框
    this.sourceF = this.source + "_f";
   
  },

  beforeDestroy() {
    clearInterval(this.timerTemp);
    clearInterval(this.setTimeOutFun);
  },

  mounted() {
    // this.setTimeOutFun = setInterval(()=>this.getMapNumMth(), 5000);
  },

  methods: {
    //手风琴悬浮
    enterMth(data) {
      this.serviceConList.forEach(item => {
        var str = item.src.substring(0, 35);
        item.src = str + "1.png";
        item.className = "page-sec2-txt";
        item.classNameActive = "img-bg";
        if (item.text == data.text) {
          data.src = str + "2.png";
          item.className = "page-sec2-txt-active";
          data.classNameActive = "img-bg-active";
        }
      });
    },

    // 地图数字
    getMapNumMth() {
      this.mapConList[0].numberTemp = 20;
      this.mapConList[1].numberTemp = 3680;
      this.mapConList[2].numberTemp = 2;
      this.mapConList[3].numberTemp = 49;
      this.getMapTimerMth();
    },

    //地图数字
    getMapTimerMth() {
      this.timerTemp = setInterval(
        () =>
          this.mapConList.forEach(item => {
            item.numberTemp++;
            if (item.numberTemp == item.number) {
              clearInterval(this.timerTemp);
              this.mapConList[0].numberTemp = 40;
              this.mapConList[1].numberTemp = 3700;
              this.mapConList[2].numberTemp = 20;
              this.mapConList[3].numberTemp = 68;
            }
          }),
        100
      );
    },

    //跳转模块
    jumpSection(data) {
      if (data == "免费体验") {
        jumpAnchorPoint("#anchor");
      } else if (data == "了解详情") {
        window.open("https://www.hvyogo.com/#/newsAndInfoDetail?id=10061");
      } else {
        window.open(
          "https://www.jdcloud.com/cn/activity/618?utm_source=MO_gxw&utm_medium=banner&utm_campaign=ggw&utm_term=NA"
        );
      }
    }
  }
};
</script>
<style lang="scss">
#carouselCon {
  .el-carousel__item:nth-child(2n) {
    .bannar_lunbo_item {
      width: 865px;
      position: absolute;
      left: 0;
      z-index: 333;
      span:nth-child(1) {
        margin-top: 277px;
        width: 900px;
      }
    }

    img {
      width: 824px;
      height: 512px;
      position: absolute;
      right: 0;
      top: 183px;
    }
  }

  .el-carousel__item:nth-child(2n + 1) {
    img {
      width: 645px;
      height: 554px;
      margin-top: 98px;
    }
  }

  .is-active {
    .el-carousel__button {
      width: 30px !important;
      height: 6px !important;
      background: #1985ff !important;
    }
  }
  .el-carousel__indicator {
    margin-bottom: 25px;
  }

  .el-carousel__arrow {
    display: none;
  }
}

#carousel {
  .el-carousel__button {
    width: 6px;
    height: 6px;
    background: #fff;
    border-radius: 8px;
    opacity: 1;
  }
}

#carousel .bannar_img img {
  width: 100% !important;
  height: 100% !important;
  margin-top: 0 !important;
}
</style>
<style lang="scss" scoped>
//bannar 轮播效果
.bannar_lunbo-con {
  display: flex;
  background-repeat: repeat-x;
  height: 720px;
  position: relative;
  .bannar_lunbo_item {
    span {
      display: block;
    }
    span:nth-child(1) {
      margin-top: 277px;
    }
    span:nth-child(1),
    span:nth-child(2) {
      // font-family: PingFangSC-Semibold;
      font-size: 50px;
      color: #ffffff;
      // width: 436px;
      text-align: left;
      line-height: 59px;
    }
    span:nth-child(3) {
      font-size: 14px;
      color: #ffffff;
      width: 515px;
      text-align: left;
      margin-top: 14px;
      line-height: 24px;
    }
    span:nth-child(4) {
      background: #1985ff;
      border-radius: 24px;
      width: 144px;
      height: 48px;
      line-height: 48px;
      color: #fff;
      font-size: 18px;
      margin-top: 48px;
      cursor: pointer;
    }
  }
}

//我们能为你做什么
.page-sec1 {
  margin-top: 78px;
  .page-sec1-list {
    width: 50%;
    float: left;
    height: 260px;
    position: relative;
    .page-sec1-list-text {
      color: #fff;
      position: relative;
      height: 100%;
      span {
        position: absolute;
        bottom: 50px;
        font-size: 22px;
        left: 58px;
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
    .page-sec1-model {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(25, 133, 255, 0.9);
      padding: 0 50px 30px 45px;
      box-sizing: border-box;
      span {
        color: #fff;
        // font-family: PingFangSC-Semibold;
        display: block;
        text-align: left;
      }
      span:nth-child(1) {
        font-size: 22px;
        margin-top: 112px;
      }
      span:nth-child(2) {
        font-size: 16px;
        margin-top: 30px;
      }
    }
  }
}

//我们的服务行业
.page-sec2 {
  display: flex;
  justify-content: space-between;
  margin-top: 82px;

  .page-sec2-list {
    position: relative;
    height: 408px;

    .img-bg {
      background-repeat: no-repeat;
      background-size: 100%;
      width: 120px;
      height: 100%;
    }

    .img-bg-active {
      width: 360px;
      background-repeat: no-repeat;
      background-size: 100%;
      height: 100%;
    }

    .page-sec2-txt {
      width: 100%;
      height: 100%;
      background-color: rgba(0, 24, 71, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99;
      color: #fff;
      font-size: 18px;
      i {
        font-style: normal;
        width: 10px;
        display: inline-block;
        margin-top: 160px;
        &::after {
          display: block;
          content: " ";
          background: url(../../../static/pc/indexPage/icon_circle.png)
            no-repeat center;
          width: 8px;
          background-size: 100%;
          height: 60px;
          margin-top: 13px;
          margin-left: 5px;
        }
      }
    }

    .page-sec2-txt-active {
      width: 150px;
      height: 150px;
      background-color: rgba(25, 133, 255, 0.5);
      display: block;
      position: absolute;
      text-align: center;
      color: #fff;
      font-size: 22px;
      line-height: 150px;
      border-radius: 50%;
      position: absolute;
      bottom: 78px;
      font-style: normal;
      left: 50%;
      margin-left: -75px;
    }
  }
}

.page-sec3 {
  background: #171e2e;
  margin-top: 82px;
  padding-top: 78px;
  padding-bottom: 67px;
  .page-sec3-con {
    display: flex;
    justify-content: space-between;
    .page-sec3-img {
      width: 840px;
      height: 670px;
    }

    .page-sec3-sum {
      .page-sec3-sum-list {
        width: 305px;
        height: 133px;
        border: 1px solid #3b414e;
        margin-top: 20px;
        font-family: DINAlternate-Bold;
        position: relative;
        span:nth-child(1) {
          font-size: 50px;
          color: #1985ff;
          font-weight: bold;
          margin-top: 10px;
          display: block;
        }
        span:nth-child(2) {
          color: #cfcfcf;
          display: block;
          // font-family: SourceHanSansSC-Medium;
          font-size: 18px;
          margin-top: 8px;
        }
      }
    }
  }
}

//合作伙伴
.page-sec4 {
  margin-top: 60px;
  img {
    width: 100%;
  }
}

//过渡动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/indexPage.vue